<template>
    <div>
        <Breadcrumbs :type="type" :header="title" :url="url"></Breadcrumbs>
        <div class="max-w-2xl bg-white rounded-md shadow overflow-hidden">
            <form @submit.prevent="store">
                <div class="flex flex-wrap -mb-8 -mr-6 p-8">
                    <text-input v-model="form.title" :error="form.errors.title" class="pb-8 pr-6 w-full lg:w-1/2"
                        label="Title" required="true" placeholder="i.e Registration SMS" />
                    <text-input v-model="form.slug" :error="form.errors.slug" class="pb-8 pr-6 w-full lg:w-1/2"
                        label="Slug" required="true" placeholder="i.e registration-sms" />
                    <select-input v-model="form.type" :error="form.errors.type" class="pb-8 pr-6 w-full lg:w-1/2"
                        label="Type" required="true">
                        <option :value=null>Select Type</option>
                        <option value='sms'>SMS</option>
                        <option value='email'>Email</option>
                        <option value='push'>Push</option>
                    </select-input>
                    <div class="w-full mb-3">
                        <div class="flex justify-between ">
                            <h6 class="text-lg font-semibold mb-4">Phone Numbers </h6>
                            <button class="flex items-center gap-1 ml-auto text-[11px] font-semibold" type="button"
                                @click="addNumber()">
                                <i class="far fa-plus-circle"></i> Add
                            </button>
                        </div>
                        <div v-for="(item, index) in form.details" :key="item.id" class="flex items-center mb-1">
                            <text-input v-model="item.number" class="flex-1" label="Phone Number" required="true"
                                placeholder="i.e 9123456789" />
                            <status-toogle-button v-model="item.status" class="w-24 mt-4"></status-toogle-button>
                            <i class="fa-duotone fa-trash right-0 text-red-700 cursor-pointer mt-4" role="button"
                                @click="removeNumber(index)"></i>
                        </div>
                    </div>
                    <status-toogle-button v-model="form.status" :error="form.errors.status" label="Status"
                        class="pb-8 pr-6 w-full lg:w-1/2"></status-toogle-button>
                </div>
                <Button :type="type" :name="title" :url="createUrl" :loading="form.processing"></Button>
            </form>
        </div>
    </div>
</template>

<script>
import Breadcrumbs from '@/Shared/Breadcrumbs'
import Button from '@/Shared/Button'
import Layout from '@/Shared/Layout'
import LoadingButton from '@/Shared/LoadingButton'
import SelectInput from '@/Shared/SelectInput'
import StatusToogleButton from '@/Shared/StatusToogleButton'
import TextInput from '@/Shared/TextInput'
import { Head, Link, useForm } from '@inertiajs/inertia-vue3'
import { ref, toRefs, inject } from 'vue'
export default {
    components: {
        Head,
        Link,
        LoadingButton,
        SelectInput,
        TextInput,
        Breadcrumbs,
        StatusToogleButton,
        Button
    },
    layout: Layout,
    remember: 'form',
    setup() {
        const form = useForm({
            title: null,
            slug: null,
            type: null,
            details: [],
            status: true
        })
        const type = ref('create')
        const title = ref('Notification Setting')
        const url = ref('/backend/notification-settings')
        const createUrl = ref('')
        const swal = inject('$swal')

        const store = () => {
            swal({
                title: 'Are you sure?',
                text: "You want to proceed with this action",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Confirm',
                cancelButtonText: 'Cancel',
            }).then((result) => {
                if (result.isConfirmed) {
                    form.post(`${url.value}`, { forceFormData: true, })
                    swal.fire(
                        'Added!',
                        'Your infomation has been Added.',
                        'success'
                    )
                }
            });

        }

        // Function to add a new phone number
        const addNumber = () => {
            form.details.push({ id: form.details.length + 1, number: '', status: true });
        };

        // Function to remove a phone number
        const removeNumber = (index) => {
            form.details.splice(index, 1);
        };
        return {
            form,
            type,
            title,
            url,
            createUrl,
            store,
            addNumber,
            removeNumber
        }
    }
}
</script>
